// Tutor CoursesPage — full list of the tutor's own courses.
import { useMemo } from "react";
import { useAuth } from "../../hooks/useAuth.js";
import { useFetch } from "../../hooks/useApi.js";
import Badge from "../../components/shared/Badge.js";
import type { Course, PaginatedResult } from "@dm-lms/shared/types";

export default function CoursesPage() {
  const { user } = useAuth();
  const { data, isLoading, error } = useFetch<PaginatedResult<Course>>("/api/courses?page=1&pageSize=100");

  const myCourses = useMemo(
    () => (data?.items ?? []).filter((course) => course.tutorId === user?.id),
    [data, user]
  );

  return (
    <div className="dm-page">
      <h1 className="text-2xl font-semibold text-dm-navy mb-6">My Courses</h1>

      {isLoading && <p className="text-dm-slate text-sm">Loading courses…</p>}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {!isLoading && !error && (
        myCourses.length === 0 ? (
          <p className="text-dm-slate text-sm">You have no assigned courses yet.</p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 text-left text-dm-slate">
                <tr>
                  <th className="px-4 py-3 font-medium">Code</th>
                  <th className="px-4 py-3 font-medium">Title</th>
                  <th className="px-4 py-3 font-medium">Mode</th>
                  <th className="px-4 py-3 font-medium">Capacity</th>
                  <th className="px-4 py-3 font-medium">Duration</th>
                  <th className="px-4 py-3 font-medium">Price (KES)</th>
                  <th className="px-4 py-3 font-medium">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {myCourses.map((course) => (
                  <tr key={course.id}>
                    <td className="px-4 py-3 text-dm-navy font-medium">{course.code}</td>
                    <td className="px-4 py-3">{course.title}</td>
                    <td className="px-4 py-3 capitalize">{course.mode}</td>
                    <td className="px-4 py-3">{course.capacity}</td>
                    <td className="px-4 py-3">{course.durationHours}h</td>
                    <td className="px-4 py-3">{course.price.toLocaleString()}</td>
                    <td className="px-4 py-3">
                      <Badge tone={course.isPublished ? "green" : "gray"}>
                        {course.isPublished ? "Published" : "Draft"}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
